export const base = 'dashboardMonthly';

export const getDashBoardMonthly = `${base}/dashboard`;
